import React from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { QuantityDiscount } from "../ProductDetailPageResult";
import DivideByUnitPrice from "./DivideByUnitPrice";
import LotPricingPopover from "./LotPricingPopover";

interface Props {
  product: {
    mustBuy: number;
    startBuy: number;
    unitOfMeasure: string;
    price: {
      price: number;
      quantityDiscounts: QuantityDiscount[];
    };
  };
  quantityDiscounts: QuantityDiscount[];
  divideByUnit?: string;
  divideQuantity: number;
}

const QuantityDiscountTable = ({
  product,
  quantityDiscounts,
  divideByUnit,
  divideQuantity,
}: Props): JSX.Element => {
  const { unitOfMeasure } = product;

  const qtyDiscountsForTable = [...quantityDiscounts];

  const getTableHeader = (discount: QuantityDiscount) => {
    if (discount.isLotDiscount) {
      return (
        <label>
          {`Lots of ${discount.startQuantity}: `} <LotPricingPopover />
        </label>
      );
    }

    let headerSuffix = "";

    if (!discount.endQuantity) {
      headerSuffix = " or more";
    } else if (discount.startQuantity < discount.endQuantity) {
      headerSuffix = ` - ${discount.endQuantity}`;
    } else if (discount.startQuantity > discount.endQuantity) {
      headerSuffix = "+";
    }

    return `${discount.startQuantity}${headerSuffix}`;
  };

  const divideByUnitCssClass = "text-xs block";

  return qtyDiscountsForTable?.length > 0 ? (
    <table className="table qty-table-border">
      <tbody>
        <>
          {qtyDiscountsForTable.map((item) => (
            <tr key={item.price}>
              <th>{getTableHeader(item)}</th>
              <td className="text-left pl-2 py-2 leading-none">
                {formatAsCurrency.formatIfUndefined(item.price)}
                <span className="each">/{unitOfMeasure}</span>
                {!!divideByUnit && divideQuantity > 0 && (
                  <DivideByUnitPrice
                    divideByUnit={divideByUnit}
                    divideQuantity={divideQuantity}
                    price={item.price}
                    cssClass={divideByUnitCssClass}
                  />
                )}
              </td>
            </tr>
          ))}
        </>
      </tbody>
    </table>
  ) : (
    <></>
  );
};

export default QuantityDiscountTable;
